import { Link } from "react-router-dom";
import { PlanMarketingCards } from "../components/PlanMarketingCards";
import { WebsiteChrome } from "../components/WebsiteChrome";

export function PricingPage() {
  return (
    <WebsiteChrome activeNav="pricing">
      <main className="site-pricing-main" data-testid="pricing-page">
        <header className="site-pricing-hero">
          <h1>Choose the plan that fits your team</h1>
          <p>
            Simple pricing. No hidden fees. Cancel anytime. Every workspace has its own subscription — start free, then
            upgrade when you are ready to execute.
          </p>
        </header>

        <PlanMarketingCards />

        <section className="site-pricing-notes" aria-labelledby="pricing-notes-heading">
          <h2 id="pricing-notes-heading">How billing works</h2>
          <ul>
            <li>
              <strong>Free</strong> includes activity, chat, and team members for every workspace.
            </li>
            <li>
              <strong>Pro</strong> unlocks tasks, Seneca AI coaching, check-ins, development plans, calendar, Outlook
              sync, metrics, celebrations, and core workspace features on web and mobile — $39.99 per workspace / month.
            </li>
            <li>
              <strong>Operations</strong> includes everything in Pro plus Alenio Go (checklists, temperature checks,
              briefings, walks, and execution tools) — $69.99 per workspace / month. Self-serve checkout is coming soon.
            </li>
            <li>Subscriptions are billed per workspace on the web. Only the workspace owner can upgrade or manage billing.</li>
          </ul>
        </section>

        <section className="site-pricing-bottom-cta">
          <h2>Ready to run better every day?</h2>
          <p>Create a free account, invite your team, and upgrade when you need execution tools.</p>
          <div className="site-v2-hero-cta site-pricing-bottom-actions">
            <Link to="/sign-up" className="site-v2-btn site-v2-btn-primary">
              Create free account
            </Link>
            <Link to="/login" className="site-v2-btn site-v2-btn-outline site-pricing-btn-on-light">
              Log in
            </Link>
          </div>
        </section>
      </main>
    </WebsiteChrome>
  );
}
